module.exports = __webpack_public_path__ + "media/img/logos/2023/pride_day-e1a29d436156e63525f6cc901e34d141.svg";